import type { PlatformComponentProps } from "@b2bportal/core-types";
import { ReviewPage, useReviewPage, useReviewPageRoute } from "@tenant/flights";

export const ReviewPageRoute = ({
  className,
  children,
}: PlatformComponentProps) => {
  useReviewPageRoute();
  const data = useReviewPage();
  return (
    <ReviewPage className={className} {...data}>
      {children}
    </ReviewPage>
  );
};
